import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompsetSidebarItem from 'lumen/components/hotel/benchmark-insight/competitors/smart-compset/tab-smart-compset-sidebar-item';
import type { BeniSmartCompset } from 'lumen/models';

interface HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompsetSidebarSignature {
  Args: {
    smartCompsets: BeniSmartCompset[];
  };
}

const HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompsetSidebar =
  <template>
    <div class="tab-smart-compset__sidebar">
      <h2 class="mt-100 mb-100">{{t
          "benchmark_insight.competitors.smart_compset"
        }}</h2>
      <div class="divider-line mt-600 mb-600" />
      {{#each @smartCompsets as |smartCompset|}}
        <HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompsetSidebarItem
          @isValid={{smartCompset.valid}}
          @name={{smartCompset.name}}
        />
      {{/each}}
    </div>
  </template> satisfies TOC<HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompsetSidebarSignature>;

export default HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompsetSidebar;
